import Status from './Status';

export default Status;



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/components/UI/Status/index.js